import * as types from "../types";
import backend from "../api/api";
import { store } from "../store";

const getConfig = () => {
  const token = store.getState().auth.token;
  return {
    headers: {
      Authorization: `Token ${token}`,
    },
  };
};

export const getHRMSettings = () => async (dispatch) => {
  try {
    const response = await backend.get("api/hrm/hrm-settings/", getConfig());
    if (response.status === 200) {
      // The viewset returns a list; grab the first (and only) object
      const data = response.data.results
        ? response.data.results[0]
        : response.data[0] ?? response.data;
      dispatch({ type: types.GET_HRM_SETTINGS, payload: data });
    }
  } catch (error) {
    console.log(error);
  }
};

export const updateHRMSettings = (formValues) => async (dispatch) => {
  try {
    const response = await backend.post(
      "api/hrm/hrm-settings/",
      { ...formValues },
      getConfig()
    );
    if (response.status === 200) {
      dispatch({ type: types.UPDATE_HRM_SETTINGS, payload: response.data });
    }
  } catch (error) {
    console.log(error);
  }
};
